// extracted by mini-css-extract-plugin
export default {"profile_header":"BSProfile_profile_header__vY1Fg"};